import 'react-toastify/dist/ReactToastify.css'

import './styles/main.sass'
import App from './layout/App'
import { createRoot } from 'react-dom/client'

const root = createRoot(document.getElementById('root'))

root.render(<App/>)